var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChapterDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3678 16.7712C11.3678 17.5651 10.7242 18.2087 9.9303 18.2087C9.13639 18.2087 8.4928 17.5651 8.4928 16.7712C8.4928 15.9773 9.13639 15.3337 9.9303 15.3337C10.7242 15.3337 11.3678 15.9773 11.3678 16.7712Z",
    fill: "#001B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3678 11.5C11.3678 12.2939 10.7242 12.9375 9.9303 12.9375C9.13639 12.9375 8.4928 12.2939 8.4928 11.5C8.4928 10.7061 9.13639 10.0625 9.9303 10.0625C10.7242 10.0625 11.3678 10.7061 11.3678 11.5Z",
    fill: "#001B4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3678 6.22876C11.3678 7.02267 10.7242 7.66626 9.9303 7.66626C9.13639 7.66626 8.4928 7.02267 8.4928 6.22876C8.4928 5.43485 9.13639 4.79126 9.9303 4.79126C10.7242 4.79126 11.3678 5.43485 11.3678 6.22876Z",
    fill: "#001B4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1595 16.7712C16.1595 17.5651 15.516 18.2087 14.722 18.2087C13.9281 18.2087 13.2845 17.5651 13.2845 16.7712C13.2845 15.9773 13.9281 15.3337 14.722 15.3337C15.516 15.3337 16.1595 15.9773 16.1595 16.7712Z",
    fill: "#001B4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1595 11.5C16.1595 12.2939 15.516 12.9375 14.722 12.9375C13.9281 12.9375 13.2845 12.2939 13.2845 11.5C13.2845 10.7061 13.9281 10.0625 14.722 10.0625C15.516 10.0625 16.1595 10.7061 16.1595 11.5Z",
    fill: "#001B4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1595 6.22876C16.1595 7.02267 15.516 7.66626 14.722 7.66626C13.9281 7.66626 13.2845 7.02267 13.2845 6.22876C13.2845 5.43485 13.9281 4.79126 14.722 4.79126C15.516 4.79126 16.1595 5.43485 16.1595 6.22876Z",
    fill: "#001B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChapterDots);
export default __webpack_public_path__ + "static/media/ChapterDots.9691d4ca2a2b79630bbab859fcea8e31.svg";
export { ForwardRef as ReactComponent };